import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview"]

  preview() {
    const files = this.inputTarget.files
    this.previewTarget.innerHTML = ""

    for (const file of files) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const img = document.createElement("img")
        img.src = e.target.result
        img.className = "w-full h-20 object-cover rounded"
        this.previewTarget.appendChild(img)
      }
      reader.readAsDataURL(file)
    }
  }
}
